/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { OralExamConfigQuestionCount } from './oralExamConfigQuestionCount';
import type { OralExamConfigSecondsPerQuestion } from './oralExamConfigSecondsPerQuestion';
import type { OralExamConfigResolvedQuestionCount } from './oralExamConfigResolvedQuestionCount';
import type { OralExamConfigResolvedSecondsPerQuestion } from './oralExamConfigResolvedSecondsPerQuestion';
import type { OralExamQuestion } from './oralExamQuestion';
import type { OralExamConfigGeneratedAt } from './oralExamConfigGeneratedAt';
import type { OralExamConfigGenerationPromptVersion } from './oralExamConfigGenerationPromptVersion';
import type { OralExamConfigLastEditedAt } from './oralExamConfigLastEditedAt';
import type { OralExamConfigQuestionPoolLock } from './oralExamConfigQuestionPoolLock';
import type { OralExamConfigRegisteredExamAt } from './oralExamConfigRegisteredExamAt';

/**
 * Oral exam configuration (API view).
 */
export interface OralExamConfig {
  questionCount?: OralExamConfigQuestionCount;
  secondsPerQuestion?: OralExamConfigSecondsPerQuestion;
  resolvedQuestionCount?: OralExamConfigResolvedQuestionCount;
  resolvedSecondsPerQuestion?: OralExamConfigResolvedSecondsPerQuestion;
  questionPool?: OralExamQuestion[];
  generatedAt?: OralExamConfigGeneratedAt;
  generationPromptVersion?: OralExamConfigGenerationPromptVersion;
  lastEditedAt?: OralExamConfigLastEditedAt;
  questionPoolLock?: OralExamConfigQuestionPoolLock;
  registeredExamAt?: OralExamConfigRegisteredExamAt;
  questionPoolUnavailable?: boolean;
}
